import * as Modals from './components/Modal';
export const Modal = Modals;
